<div *ngIf="visible" class="rollup-tabs-content-card-header-container">
  <div class="rollup-tabs-content-card-header py-6 px-11 align-baseline">
    <div class="row no-gutters">
      <div class="col">
        <div class="w-100"></div>
      </div>
      <div
        class="col-sm-auto d-flex align-items-end justify-content-end action-elements-wrap"
      >
        <div class="d-flex flex-column">
          <app-toolbar-buttons-rapido
            #getItButton
            [hasEcontentIssues]="hasEcontentIssues"
            [label]="
              materialTab.translationKey
                ? (materialTab.translationKey | translate)
                : materialTab.name
            "
            [tabName]="materialTab.name"
            [recordId]="materialTab.recordIds"
            [isElectronicResource]="isElectronic"
            [availability]="availabilityUpdateInfo?.status"
            [reserve]="availabilityUpdateInfo?.reserve"
            [eVendorAvailabilityPending]="
              availabilityUpdateInfo?.eVendorAvailabilityPending
            "
            [eResourceUrls]="materialTab?.availability.urls"
            [resourceId]="fgId"
            [title]="fgTitle"
            (getIt$)="getIt$.emit($event)"
            (placeHold$)="placeHold$.emit($event)"
            (checkLocationAndEditionInfo$)="onCheckEditions()"
          >
          </app-toolbar-buttons-rapido>
        </div>
      </div>
    </div>
  </div>

  <div class="location-edition-table-container d-flex flex-column">
    <div class="d-flex flex-row">
      <button
        (click)="toggleLocationAndEditionInfo()"
        class="toggle-table-btn text-wrap px-5"
        data-automation-id="toggle-edition-information-button"
        [attr.aria-expanded]="tableExpanded"
        [attr.aria-label]="
          'editionInformationForTitle' | translate : { title: fgTitle }
        "
      >
        <span
          *ngIf="!isElectronic; else electronicInfo"
          translate
          data-automation-id="loc-and-edtn-info"
          class="mr-2"
          >locationAndEditionInfoBtn</span
        >
        <ng-template #electronicInfo>
          <span translate data-automation-id="check-edtn-info" class="mr-2"
            >editionInfoBtn</span
          >
        </ng-template>
        <fa-icon
          class="arrow-icon"
          [icon]="tableExpanded ? arrowIconUp : arrowIconDown"
        ></fa-icon>
      </button>
      <div
        class="editions-search-container d-flex flex-row align-items-center justify-content-end w-100 px-5"
        data-automation-id="editions-search-bar"
        (click)="$event.stopPropagation()"
      >
        <div class="d-flex flex-row align-items-center">
          <fa-icon [icon]="searchIcon" class="position-absolute mx-1"></fa-icon>
          <input
            class="w-100 px-5 py-1 m-0"
            #editionsSearchInput
            [attr.aria-label]="'searchEditionsLabel' | translate"
            (keyup)="onEditionsSearch($event.target.value)"
            (click)="$event.stopPropagation()"
          />
        </div>
      </div>
    </div>

    <app-location-and-edition-table-rapido
      *ngIf="tableExpanded"
      [editions]="materialTab.editions"
      [label]="materialTab.translationKey ? (materialTab.translationKey | translate) : materialTab.name"
      [tabName]="materialTab.name"
      [nonIntegratedLogo]="nonIntegratedLogo"
      (tableInited)="onTableInited()">
    </app-location-and-edition-table-rapido>

  </div>
</div>
